<template>

<div class="head">

    <div class="head-safeguard">

        Safeguarding        

    </div>

    <div class="head-inner inner">

        <router-link :to="{ path: '/' }" class="head-logo" />

        <div class="head-actions">

            <div class="head-actions-item is-search"><span>Search</span></div>

            <div class="head-actions-item is-menu" v-on:click="onMenuClick"><span>Menu</span></div>

        </div>

        <div class="head-menu" v-if="is.menu || (window.is.desktop && !isPreview)" v-on:mouseleave="onMouseLeave">

            <router-link class="head-menu-item" :to="{ path: page.url }" v-for="page in menuFinal" :key="page.id" v-on:mouseenter.native="onMouseEnter(page.id)">

                <div class="head-menu-item-text">{{ page.name }}</div>

                <div class="head-dropdown" :class="{'is-many': page.subpages.length > 4}" v-if="window.is.desktop && page.subpages.length > 1 && is.over === page.id" v-on:mouseenter="onMouseEnter(page.id)">

                    <router-link :to="{ path: subpage.url }" class="head-dropdown-item" v-for="subpage in page.subpages" :key="subpage.id">{{ subpage.name }}</router-link>

                </div>

            </router-link>

            <div class="head-menu-close" key="close" v-if="!window.is.desktop" v-on:click="onMenuCloseClick" />

            <div class="head-menu-item is-search" key="search" v-if="window.is.desktop" />

            <div class="head-submenu" key="submenu" v-if="!window.is.desktop">

                <router-link class="head-submenu-item" :to="{ path: page.url }" v-for="page in item.site.settings.head_links" :key="page.id">

                    {{ page.name }}

                </router-link>

                <div class="head-submenu-item is-phone" key="phone">{{ item.site.settings.head_phone }}</div>

            </div>

        </div>

        <div class="head-submenu" v-if="window.is.desktop && !isPreview">

            <router-link class="head-submenu-item" :to="{ path: page.url }" v-for="page in item.site.settings.head_links" :key="page.id">

                {{ page.name }}

            </router-link>

            <div class="head-submenu-item is-phone" key="phone">{{ item.site.settings.head_phone }}</div>

        </div>

    </div>

</div>

</template>

<script>

export default {

    props: ['item'],

    data: function() {
    
        return {
            is: {
                menu: false,
                over: false
            },
            timer: false
        }
    
    },

    computed: {
    
        isPreview: function() {
        
            return process.env.VUE_APP_TYPE === 'backend'
        
        },
    
        menuFinal: function() {
        
            var menu = []
            var parentIndex = {}
            
            this.$_.each(this.item.site.menu, function(page) {

                if (page.parent === '') {
                
                    page.subpages = []

                    parentIndex[page.id] = menu.length
            
                    menu.push(page)

                }
            
            }.bind(this))
            
            this.$_.each(this.item.site.menu, function(page) {

                if (parentIndex[page.parent] !== undefined) {
                
                    menu[parentIndex[page.parent]].subpages.push(page)

                }
            
            }.bind(this))

            return menu
        
        }
    
    },

    watch: {

        $path: function() {

            this.is.menu = false

        }

    },

    methods: {

        onMenuCloseClick: function() {

            this.is.menu = false

        },
    
        onMenuClick: function() {
        
            this.is.menu = true
        
        },

        onMouseEnter: function(id) {
        
            clearTimeout(this.timer)
            this.is.over = id
        
        },

        onMouseLeave: function() {
        
            this.timer = this.$_.delay(function() {
            
                this.is.over = false

            }.bind(this), 1000) 
        
        }
    
    }

}

</script>

<style scoped>

.head {
    background-color: #fff;
}

.head-inner {
    height: 153px;
}

.head-dropdown {
    position: absolute;
    top: 60px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 1000;
    display: grid;
    grid-column-gap: 10px;
    grid-template-columns: 240px;
    padding: 5px 0px 20px 0px;
}

.head-dropdown:before {
    position: absolute;
    content: '';
    display: block;
    border-top: 1px solid #D5E3D7;
    top: 0px;
    left: -3000px;
    right: -3000px;
    bottom: 0px;
    background-color: #fff;
}

.head-menu-item:not(.is-search):hover:after {
    display: block;
    position: absolute;
    content: '';
    bottom: -20px;
    width: 100%;
    height: 5px;
    background-color: #4BA574;
}

.head-dropdown.is-many {
    grid-template-columns: 240px 240px;
}

.head-dropdown-item {
    font-size: 14px;
    line-height: 18px;
    font-weight: 400;
    padding: 8px 30px;
    border-bottom: 1px solid #D5E3D7;
    color: #45464b;
}

.head-dropdown-item:hover {
    font-weight: 500;
}

.head-safeguard {
    background-color: #FDF9F3;
    color: #45464B;
    font-weight: 500;
    text-transform: uppercase;
    display: none;
    text-align: center;
}

.is-tablet .head-safeguard {
    display: block;
    font-size: 13px;
    height: 28px;
    line-height: 28px;
}

.is-mobile .head-safeguard {
    display: block;
    font-size: 9px;
    height: 24px;
    line-height: 24px;
}

.is-tablet .head-inner {
    height: 80px;
    display: flex;
    align-items: center;
    padding: 10px;
    justify-content: space-between;
}

.is-mobile .head-inner {
    height: 64px;
    display: flex;
    align-items: center;
    padding: 10px;
    justify-content: space-between;
}

.head-logo {
    position: absolute;
    left: 0px;
    bottom: 30px;
    display: block;
    width: 211px;
    height: 69px;
    background-size: contain;
    background-position: 0px 50%;
    background-repeat: no-repeat;
    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAaYAAACKCAYAAADhaO76AAAABHNCSVQICAgIfAhkiAAAIABJREFUeF7tXT1zG0mSrQYUMZQ1o18wHOfck9wNgUe564hyTtAaJ8g6c6g448zheOuNZJ41kLOizhkq7iLOFCTo1hX1Cwb6BSNas3shoC+zmyDxUZX10VWNbuB1BKXRsLo+XlbXq8zKysxUG56HvfvUzUOVqdsqp59MfUN/f6a/z+nvc9WdvlB/+et5G4aCPgIBIAAEgICMQNZYgAaH36i/ffleqWxAfdx36OdEZdmJevnuhUNZFAECQAAIAIGGItA8YuofEglNfyBN6KjQjPwfEJQ/ZngDCAABINAYBJpDTHNCUoo1pBjPRKl8qPZuPFfD0ecYFaIOIAAEgAAQSI/A5okpjJDeEjT/5AQPn0V1smOY+JzQQiEgAASAwMYR2BwxXZ8hnTiiQGdH3RN1OiJN6PL50x9uq1n3mP712FpHnp2rbPZUnb4fWcuiABAAAkAACGwMgc0Q06PeEZ0h/USj3ncYOWlH3cESIa2+VGpdTHAOBKXOVNYlglogOIdOoAgQAAJAAAjUg0C9xFQSyM80tEOH4X0i5wcywY3PHMqWRXwISuWkfb3/0bluFAQCQAAIAIFaEKiPmB4ekOs3kYGTp132o9rrPAt2WnAlKDbvdb88wR2oWuYaGgECQAAIOCGQnpj4LOl30pIycv+2P6/JbHcczczWv0uaGd1tsjpKQHuyiwYlgAAQAAL1IJCWmJgY8uwXBy3pE2lTdI6UyDGh3xsQnM/o52sjrIVzROdBNFKsR35oBQgAASCwdQikI6b+3R8utRUJtAsiLYrWMGbSSPsUXoDTITXC4Y30TxnmiBwjxlwODxAAAkAACGwAgfjE5G66e632uoPgc6RQsEqPQCYes/YEx4hQdPEeEAACQKAyAnGJiZ0O8hmZ7vLbQs9YSxp4edtVHuZKBW7a05m62X1SO3HGHivqAwJAAAi0DIF4xMSXXafdN5bzpM1oSSahlGdP7L6uf3Du1LLpjO4CASCwDQjEISY7KV0QWORt18CzmzJ6BN+V+lYrUD536k7vwaV8G6Y7xgAEgEAbEKhOTHxmMyOtw3w/6SO5gB812tutNO0xOenj74Gc2jCX0UcgAAS2BIFqxGQzhSn1ghwcjltzTtPvDUmu+rBGIKctmfIYBhAAAk1HIJyYysurb4QBPmmk6c4mkf7BCd2pIld3zQNysqGH3wMBIAAEKiMQRkzymRKdJ+Vkukt0WbbykB0qkDRBkJMDgCgCBIAAEAhHwJ+YbKTUmR5uhaOAjZxudr9rjYkyfH7gTSAABIBA7Qj4EVN5efZXg6PDJ9WZHm0FKc3FIJIThTC62bkHcqp9zqJBIAAEthwBP2J6ePDBcHn2Izk5HG7lIi07eAzpHO3Jls8RDA8IAAEgUCsC7sTU7/FF1IGmdxdESvtbSUpXmpPgEKEoRcfpu5NapYbGgAAQAAJbjIAbMZm1hgsy323HmZJNyJIreaYebDTEkq3v+D0QAAJAoEUI2ImpjIzwQasp7QopXZ85jeg/1y/hsqcenCFaNO3RVSAABJqMgExMZUQEJqV9zSDaeU+pijRKPM6pivXwRbk6U6/GD6pUj3eBABAAAkCAbsiKIDy6+4wS/VFK9NVnh89VzBoko/m0ltxSmLlAAAgAgS1GwExM5sgOb8kT7XCLMbEPzXTmViQa7N5pdFxA++hQAggAASCwUQQEYur9qjHhbb8Hnqs4+j0O+qrLhjsi4r7nWg3KAQEgAASAwDICemIyxYury/vs0cFjleeDIGEVWkv+PHlIpPK8aUJ9XM+EWxdOQQDhJSAABIBAsxFYJyZzdIfXpAkcJR9Omfr8l0rt1OUlZ+7rhLD6rtIY8DIQAAJAYEcRWCcmvbZUnwlPiu7tJaT8XnKtiftjMunBEcJLWigMBIAAEJgjsExMRm2pRi+8fm9EndMn7POSW13EdLivVOFCvmzSq0tr88IEhYEAEAACzUdgmZg2rS2VGki7iKnosylkUY2E3vy5hh4CASAABJwQWCEmrSdevRdpdcR0Os5U4b5ueLLsNp1L/bT825o0Jm5UcoTY697a6jiCTtMMhYAAEAAC7ghcE5P+IL++s6V5n03EJI1Je+eqRmKC1uQ+41ASCAABIGBB4JqYdEFK2e365fvjWlFsKzGVWtNvGqzgoVfrBEJjQAAItB2BRWLK1wdDWVpPR5NaB9lWYiq0JsOl2870zlYlUKx1QqAxIAAEdg2Bkpj0ZryPdBfndu2AtJuYBoQX561aeeAEUfs8QoNAAAi0FoFLYtIEa92EGa/UOkb057K7ODs/SE8Tzpi4f2ZzHuILtvYTQceBABCoG4Fywe/rvPFqdh6Yj7zNxFRiyXea/nFNkDZyrVvyaA8IAAEg0FAEMuMuf1MLaduJyZgqZAPndQ2ddOgWEAACQEBC4PJ+UPZmpdDmTE9tJyZjGvoNaaCY/0AACACBliFAxKSNWvCCHB8GGxlL64mJLwKvET1BCWLayHxCo0AACLQOgUxpTU8b9CJrOzGV50wa1/sNYtq6aYkOAwEgsMsIkMak8YLbZGRsENMuz0eMHQgAASCg9MS0SbPTdhDTiObWSoR0aEz43oAAEAACLggwMWnMThs8DwExucgNZYAAEAACW4sAiCmFaLWpO6AxpYAadQIBILB9CICYUsgUxJQCVdQJBIDAjiAAYkohaBBTClRRJxAAAjuCAIgphaBBTHpUOZbg36fr4Zq49Mvx2xSiEOt81FtxULks/VX3I5I7RpBG/3BfZdNv12rahKwjDAdV1IdAODE9Onis8tl+/K5mA6pzuV5beCRtEFc1pEutk/j9UxQV4/1IrHdTxFRGnXicYMxcJV+6Jkw9noKIZvfVLD+itw7JB/Qby9sjykR8rrrTF0nShPzpD7fVtPuY+sH9sc1dnjvcnzP1avzaY9R8j80sh870afSxNUXuc3nn+SHhdiTKO884puRQ3ey88NoEsAxn3ZVs1VfS8Z+ji4Lt91Yj4JS/zfKPlfPSMUmrqSbzwGUHYrTBVZVrz7pDW6z6Vz+ERO2FEdPDgw8krPpSYoQRk9da4lfY4siwMWLSRvHwG5qxtIfzRhFl/cv3Ks+OHchI3yIvXNnsqXUT4DK6YhOVnziQkam2CY3lmXr17rlLc4ZoKpevJvB41UdvceqqvZCj3BnjWf7MW965+kwr/4k7tqbIKgWD/KhO37Gcwx6th3JRVfUQbY96x0QXJkK97G+EeJopx6BDNVF7/sSk107CJoLrW00jJv6YXo1vGbu/y8RU7mh/qUACq7AO1V73qdeuel4DE+TvtEstNaTqD5Nl98sTq8YjEsUWElO/x5rAoCLAI5LzA6ucxfWnwcSkzeCwgliMwAaJiEJY6zTXjaqTeRuIyS1hoVkgFb8Xw+sSWe4qMRkD2FYUARPCzc4966K12ExptnvjvYO3dZU3Jd3pPZGcdomY4pDSHPURmYvviSJoIzGVm7UPtqlFWvk5aY53rOWkAiCmSvD5vPzE6WxDSwY+zXiWBTEtA5aKlOat+JBTKlK66ouFnHaFmFLI3JagtI3EZEyFo1lzOtM7Vo0cxKRBQD8xXpB9d+K5tMvFs/wzefSMvIRUpIjPEpx95WymWPYuah8xfaQxkD0/+BkaNwgF7orNd67Pogfe/hq2plpKR4QHYiOl+e5XD01pERd2ztB7Da43OiHT0x2tFtcsYkond7t5itrOzug8mh0dSM75Pn2f/C19LcpQWpzbSEwPe785z0cbMdu+sN3VmHQH7Ans5jYB1Pl73zBJjTTlJZKRKxHwB5fNhtqNRulGPiByO7EuWpl6QK7lZ0bxl55Vh5bp8ZYWimfGekpNgH/07uTXlevTwzSKmBLJ3bYZMZ2XFI4x02cEoeQ9ak670zZisuGk2/Ccjr8LXt5ATIvQJZr8wdKJ/CKIyQxovze0LDK0a+4eqdPRxCoVt0VrQpqb/sO1m5YuiJAGIrEtdjLUk2oXiEn2BLR7sfV7rEXptVPJuahtxGT/PtY/C9vmS/qQQEwgJmHXPlrfbVf0GLKu6lSg7gXRfqj7kcxdh15OCzxO63mhYSMkm5YuVGd66GUaLvpiccHXmV7qlkPd7Vll5DDXbZrEXveW3kzaInfxcqP1m+HT5btx9w2/C0/UCmICMe08Mcm7wQsipX1vUioWveIy4q8CF69/uLaFrtouVLPRuOrdugZXN1HU3Z6VmJTdYalctM0m2c70WLuJaJPGJGnwfI42655oyYk1xpt0p2k48j8TBjGBmHaemORDXfviJJskhvRr0zmEhgx6vMjF34FyH22kp1YuRtZNFHW3ZyOmqgf44rxokcZkPu/8RObo/csIIaZoEGHfD4gJxLTTxCQv1uWHV+Upd8a8o9Q/e3RutbijlO6xVXXBte3uFUWVWAxTVTdR1N1eSUzmjYPLXa/QudEWjUnS+heJu99jrUjnpfiaviH/i+E7S0zaA2E4Pyx9Z7vglSfdzUi5Y9YtaHI0ErcL2qELpbY/0rlUgm9lM8Q0oKGbY78xOWX5gyghpRYxbgsxSY4zixsl0RweEKJoZ4lJOzESfGwxF4qqdcErbx1B0UGh5vkgLswOB/FV58fq+3UTRd3t8XhLLXJi2O0vIjJSWTZUL9/RXccIT1uIyeyIs2xNkCwPISGKQEyLk6zmhSjC/PaqYhuIiQOqdoqLjv6PLk2BdL5ki23o3wP5DWnXWcXpIbSfdROF1F5suS9pLx5BgwsNii5Ih0Rrd9aYKFp5xlkFAp+cosnrH7v7++J7oreqZqNkMueFhCgCMS1Iosrkl+aQb94WU/6XwHl69dqMIkuvRlNvX+SHcBR0YzV/ABdkG7eltwjvi+7NJmlv3L8mEVMVpF02GH3R6UTfehFRnAgkJL3JJoJI+0YX9zXPSeV9z0dBTFVmvPO7E7p78sDp7olPPCrn5oWCIKYkUYWDRCMRk8viGtSo8NIuEVNBxNZL1hLCpKXklK7CkuNsXkMbiMlsTdCfd4rmPIqY8vL9sfMUBTE5Q1W1oJt3CqKL2y+DhkpidXGX7xn5mT1C+7T4HojphBb3H2JAuVSHD6mXiyuHGlrPWOvSMTbx3ew+sd7daToxhZ4Z9XsTA3bmSCd660G9G8ZERNj8tBe23EcsHHsEApdPw68MNKZ6PwBJOhIxmSII+Enbr/SuaUzLm4QB/ZN3+K7BcK/fdnEzbzoxiaZNwctO9HK1xIdcxr/e77IxxOTujeP3MUulbTu3+ierHDKkke7iFcThd8ak6Iwpq9Ca/6s4Y9q8xrQqNd4s5h0KzJvxXRx3LcpGTvV/6zwyNyuAHIJIvrYgb67dQxQlIgrjR5moPX+NiXtYmHJmtDMq0qvHPujmOpcvnNkWOv1k/UT1TPxXOeGNInw/pff4qjsUTQ6NJKbInpOS6dQmr6hC4fnYG9Gfhkjgkcft0vdGaUwbGL+ZpFibklNe8LuSN1qT3cXlIML2SA4mc55PiKJERNEOYnL5OEPL+LpmF0SpC1Oygfsr8zHvBjGZo0OvhugJnQuu70lEEHIXxLVdUzkQkxnBcvHmsygbQekX8iYT08ODD2veu3MkXEzKsgOXndiKtbC3o6a8qh+t7X0Qkw0h4aOvMeKAZEuvmwzk9BRuzjPhqK+/CWKS0SxNXkMqZIptyO/r5dZUYrIHHq46w+xp50FMVTEW3gcxhYNb54LYJDKwLQouu9Vw1EFModiF5GRqLDF5XDYOxcvFEgGNKRhd+UUQUziwdRKT1RMyIM7X4shLt9vvjWCcju8t/c7sbsvF3MwgpsbKHb6QOn7lHk6dcih2yTVqykV7dMacTfUODXmXQu44JIXkemxR27VONw2NLm5PMx/+Xc/fdLFEgJiq46ytAcQUDmztC5Tx7gUdYNO9lFfjB8GDkVOkr3s4yfb5CeWGumO9I2PqrDUz7o6lvaiavXaOs03TbQsxWTdpwV/B6ov2O00gpmhgL1cEYgoHtn5iGlBnzRGmQzUVm0uwNmusNbngkNzYn3iDW2pLH+i9fcO76yk+apdD3RpT4cCgl7vLvcM5kLYFvS3EVC3yhd+UtIUoAjH54elcGsTkDNVawboXxHLRZu886Z6KnxmNF6tp9w0F4xSuIRjMhPYFwo+ceHy/T3+mvkh5cdbHV7cc6m7PRiguJqfCJCgQnOnuUBPPmMwhiC7IdOCfU4nnW57pzdi2lDIgpvD1U3wTxBQObN0LlH1xKcfCoWpudn+0mtIeHTxWs5wC5op348xedqVpiIlSckUeUfzFp9b4iwVB3iBSKu7qmR59+vi65VB3e6XcJ/KGxHJ/yrYBMS3ATSMm+ZzM/WLs4gyTTJw2jRTEFL5+gphSYSeYdKpGgJcOtd0jTA+Ly5NL6TeyfSKj25daCRGL+FwQqRyKpGI9D7qsn/uRzc4oV9BoqcU8P6SIBUcWQpq/YrhrU7dpbQNyl8+ZrjckWff5kjMEa6F/n923b0BMWnHDnB/kaxMP1MvxWdDXLnksSqlcQExBcNtfgsZkx8hUwmWxCK5duLBcmvR4gfePj+bXHzezoN2k59eqvrSguSVzHdaHxtmU3K1a0xJwI9KceQPiEilGwLZBxCSHIKqW/kXeYJk1sVTBrE3RXNK09yUsJFGMz9q4uGrCy9hC3CDyQ4nmphYobjs1ObmeW8znVVpyektefkdG02Q6OTSLmMqzJt6Q2KI4+KwYevPolVwbREwSedjOgmyIyKSnaP7d0s6/NERhjn+Zpj0Qk21+BP2+kSGJgkay8JJDiKfyY2LThSFuXXAf3DSl1erTEIT93CBNuzy6ZhET9yguOTmYahtETFIIIpv3nMunIJvIDWZkY0gilxbNZaAxQWMKnkHpFkTqkgMxzTteRoU4ibCTfqtUd+B8YVMHXKlNc1+qkuUnMkMdO50ZpJND84jpmpw4/l0VjN1k3RTnB/kO1voVgpCPWjbn6UMUpdFgoDFpI0XDlOc2rdMtiH7ExL0tDrmnlPZADehfvmdPL4gEzpxIwA2ZeaBfzhMkxWfT1faR/uczMp2cWb0K52+nk0Mzielq3IX7N//4EFSJ7+l46CTKxhCTcI5Y1Yw3B8JmztOFKAIxOU0j/0JwfvDH7GphYHfpL/ST4rlBt84dQ82sNl/uLg8LT7c807lffyathty8ZyO1d+PcmQBChlkSJnnecT/IA0/7kKcepzjJu+dBYy7Gm0AOndlnrUdiqvYKbALkPpe3yggHLcYT2niQVyQ5zPzlr+ze7/4Ui/UXgwt/QF8XWy5IT/PocC9MmB29I0fMOezbjmkM7gjrS56+H2l/kaK9LMvh/FBVYLr3N3XGlGIsqBMIAAEgUDMCIKYUgIOYUqCKOoEAENgRBEBMKQQNYkqBKuoEAkBgRxAAMaUQNIgpBaqoEwgAgR1BAMSUQtAgphSook4gAAR2BAEQUwpBg5hSoIo6gQAQ2BEEQEwpBA1iSoEq6gQCQGBHEAAxpRA0iCkFqqgTCACBHUEAxJRC0CCmFKiiTiAABHYEARBTCkGDmFKgijqBABDYEQRATCkEDWJKgSrqBAJAYEcQADGlEDSIKQWqu1nno956QFQpm/BuooRRbxkCIKYUAt0UMZVh8h+HDymn4KWdCaUWpyjWgQFbVxsvA3r+bOxTln9UL99z1O9qT4l5HljJhF6lwKIUvPXlmNIveD79u/9O7/5R+9Zs9mf16n//x7nGMmjnfWt691x9LiKwq5zyQxkCbJoafXT3GQWx1Ud8Px3fc+7rmqyF+deZPvUO2BrcEbzYdgRATCkkuDFiipjSO6do3x1KR/Dy3YtKEJW5mX6S6+h+V5kIY4X75wVfqaG62f3ROco5E5PK/qwdYz77oxMxMYHn05+IbI688c6JoLLuU2cMtfPzslVbihmpc2K6j/yeN4F6A4EXtgUBEFMKSW4DMV3jMlJVdrv93q9U1b4Is2/adF1lsYhpXnepkdBi75AnqCoxsZY07b6h9vRpFFzmqFd/Nck4522AmFzQRpnECICYUgC8XcTEBrLPqju9522KKdNuf7BCzNrZq3d3rOXE3XqilNKsPZ2On4h9q0JMMUhpqXMOmgk0pkpTDS+nRwDElALjbSMmxqjYkXfvOJuL+J3yLON7J4g70zvexLdYcWyNaanTlrTyVYjJRaN0AvCykIucQEw+iKLsBhAAMaUAvZnExCms+fzE9Likwx6R9uB+OP6w95uzeapqOuqkxMSQCedgocRkP3+7oIbp/IiyvSpFTilXWXdtsnpNcjKfVYGYUnz1qDMiAiCmiGBeVdVIYnIw8TzqHZFmdELj0HtsFQN0qKfQloq6fvGAl1K3j7/zKL9c1ExM5GE4PjTWe5VqXbFnoHnBl4gzlJgeHnwo0s3rH9pIdI+0GmqRzjojjzz1tRkviUhxxhQ8z/BiLQiAmFLA3FZiYix4of7bdCSQE7knjwdW2Pq9IZXxc13P1ANy1+YF1/8JJabFlqQ+s4ns1fiWtmOhxCRqeZYNgJ34nxgdN6Ax+c8vvFErAiCmFHC3mZgYj3JH/sYAjV2zKcntN8P7r+n/3zf8zo30dC/HIKay3xOq3qCJGMgihJhkjBWRSmadmv0em/j02q2o4UFjsmKLAhtFAMSUAv62E1NBTj0+j9Iv0LZFs7zoq79Uy04Os+6JlpxYK7lJJqjhSDoL00ssBjGV4x7Sn3pNz6TRxScmO/lzX8szKv1ZUpafGy8uQ2NK8dWjzogIgJgignlV1XYQ04jGoz9zsXnQ9XusbR1qoP1EmsA+Lf5m4lLKbIKSZBWNmKRLygbvvPjEpNRe91YQQbvMZxCTC0oos0EEQEwpwN9lYipDEPGl2vVn0bxk1shkjzKTvGIRk+gpF5OYBJzKMdrvT4XOXRBTKHJ4ryYEQEwpgN4OYpoQNN9q4ZFMedLCvqhpic4RASGKYhGTFFYnpimPge33zBjPyWmPQg2FmDZl7XJEv9ZrwzYzrVivpG06enOm+B5RZ+sQADGlEFnbiUnSepS6IHOcOXSO+cJoacabP5JXWUiIomjEJDgUmEyYIaa8gpgcYhsWF2bzZ0rdIMeQWIF14fyQ4rNHnfEQADHFw/K6ptYTU49dtv0958QQRBozmMmcFxKiKAYxyS7Yy8S6OG9CicnqBbgyORkXNvFlHTJ3ViApyZSXac8G3b6SXA2oIP9oHmhMbiCiFCMAYkoxD9pKTOVCyZHADYsLgyUsML7mOam8zcFiVW5ViYlJaUaehKZAqpIWF0pMhdbkcllWO0kpRUk2VF8RSfma+iRiSvE9FHWCmJJBu4UVg5hSCLWJxJRnx6pDLsSrz4zC3GQzMs1llHaBXI/lCNcfyRxnilSglDkEkf490ZyXP/fK02QipiJ9R76e72lGkbw56kKe0d+Fy/W+MBUuyEtu30gAVYiJGy01zRH9lxDJwdC7ualv78ZzZ4ICMaX46lFnRARATBHBvKqqicQUY5ySFhN6ZmR2AHC7yzMfV8pYebaIFFWJicdQaqt0luQZLWM+fiaoDrnau0TOADHF+BpQR0IEQEwpwN1OYpLvF/WlcynBy06KQG4jhEXZpSEmDqJ6bM3JFIOYrgi2cCM/oX+yFuevQbm4mYOYUnz1qDMiAiCmiGBuqcZ0QaaugbgTl0MQyeY/OWeTe4ii+MT0kRIkDpxSccQkpvkkKjFlcuIfkyOKafbKd6BATCm+etQZEQEQU0Qwt5CYXtDZyrH17KJqJAeTOc8nRFE8YvpEcjyxaklL2lqE1OrSPLwmqQEVs6W8KGuStE1csE3x1aPOiAiAmCKCuQXExIvyOS1qI5V3z5xdkqX0DS6hdeSEgm4hiszERGMi77XFh509TAkMfchwXmcKjck0L8s7ZnwWZdOizGd0IKYUXz3qjIgAiCkimM0mpkTuuvJl3BjouiUn9HUXF6MuWDLWro6qTmKat106mzDhms+hjBeCccE2xsREHekQADGlwLaRzg+piMkhekFljB1CFPkT04C6pY+A7qs1bYKYGFNbTibT3StoTJVnJCpIiwCIKQW+O0VMPQ7YSualhI9LiCJfYuLuxtKaQojpUc98VvRy/NYZTSknkzIFnYXG5IwvCm4EARBTCth3hZhkj7qYyNrvNIURUxytKYSYqmSvXURWjLYBYoo5CVFXfQiAmFJgvSvEFJI+PRRvW4iiEGKyxqpzPGsKI6YJQaGP3u6iIc5xFO+PgZhCpxve2ywCIKYU+O8KMZlDENHF1FyfWVXCm0MDmbzlpFThpVkuN1T9lly/D43NShG+Xc+awohJCpQ7ITf9O1Y3/XLcginVlAoeprwUnz3qjIcAiCkeltc17QIxyQfv7hdjl8xSQvI8JolX41tmggkkphhaUxgxmc2IPMhcnVGa+SciOfV77LzB9egfk6s+nB9SfPWoMyICIKaIYF5VtQvEJJmQfEIJreIvHebLl0bDNCZuX7pH5aI1hRCTlRCZnDgArXqmXr57sQQTn+1Nuz9cBp81zWDz5gDElOKrR50REQAxRQRzZ4hJDkEkJxK04S1HkZAW23Bist7Fspw1hRAT4yCPdRWpCREVJw00R3dffEM6kwMx2WYhfr9hBEBMKQSw7RpTKHm4YC2TnqKzl1ta81boGdO8T5Ijh01rCiWmkpyG9OdjF2jcy9iIFGdM7lii5CYQMBDTJroitHk6zsQelcnW3jSs1yvdcfTwqjIIMVV3xAu2Uggim/ecy/hETzNK7XA65sV8+alMTML5VtGSIL8qxBSfnOzne9CYXGYhymwQARBTbeBvCTHJZi9z+nEfnGWNTB+iqCox2QhC0pqqElPRduUIGm4pOspxjuhP/QVf2yZQkmNdGyOfuYSyrUQAxFSb2LaFmIQF1ObS7Yq1zZynNCGKohCTTfM23QuKFF2cST/7ckxnSQOCyjUXExMSuZ53KSL6aOIEMYjJCSYU2hwCIKbasK+DmNgc9YV+NM/ejXOnezFHPGrfAAAAjklEQVQ2PIpoDx1KxZ6wDa7at53CnKt5OrPPTjmV5q+a6uHfm+r654MDEbb/fPfOBuva74t+dOgnZ3lqZJqNyBHiXH1FKdmHo89e9UvYnr4fedW1WLjQphPPv+DO4cU2IUDEdPAfje/w6bt/Ffv4L3f/Qf1f598aPY589l/q1fv/bnQf0TkgAASAQAMQ+H9086+Jy02B/gAAAABJRU5ErkJggg==');
}

.is-tablet .head-logo {
    width: 151px;   
    height: 50px;
    position: relative;
    left: auto;
    bottom: auto;
}

.is-mobile .head-logo {
    width: 112px;   
    height: 36px;
    position: relative;
    left: auto;
    bottom: auto;
}

.head-actions {
    display: none;
}

.is-tablet .head-actions {
    display: flex;
}

.is-mobile .head-actions {
    display: flex;
}

.head-actions-item {
    width: 52px;
    height: 52px;
    background-position: 50% calc(50% - 8px);
    background-repeat: no-repeat;
}

.is-mobile .head-actions-item {
    background-position: 50% calc(50% - 6px);
}

.head-actions-item.is-search {
    background-size: auto 25px;
    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAMAAAAp4XiDAAAAOVBMVEUAAABQn3BLpXRLpnRMpXRMo3RKpXVKpXRLpnNLpXRKpXVIp3hLpXRKpXRMpnNLpXNKpXVLpHRLpXQJQv7LAAAAEnRSTlMAEPDQgEBgwKCwMCDgf1DfkHDctJqvAAABW0lEQVRIx62V7ZLGEAyFSX2UKn1z/xe7s2NTJcXa2fOP6ZNITopodJjdAiKC3c0h5pKfDZ/ajJwAJ2ArOEdQBHxT0t0UO/Z0dYgN+9rlhHBKf0u5RxvkgAhGll0T7jwMoTrANKEUtUS1vaL83DtPjK5j/WzbUZWp2lWsxreAhu9Bb6I8sDSfOgqXYh/kw4YuQcdwZdpLjEmau1ZDa6Y2aqxtdGKkrbbT0nIgVYcFMneKWFriLxD9VwRWkEhZlmtZ6diVO7biS8ph193X6zPWTkNamGRhcNKAnaaS/ZV+6COGl6Mm2fuPebEyDO4Ln0tFy1L3zqYBszxzt35N+HPwYcEc3tBRHCxP1D6++bfz1DqeV0J8El7OX6SGAN4dhVyljgPeOqrDK2D9bQ5nhOFQMGQnMQxyFeBi6U7fbRmVsxasdUrnHcYM9U/MJZYZEMsMiGVGiSXmAsjEqr4Aeaw0BijEEdQAAAAASUVORK5CYII=');
}

.head-actions-item.is-menu {
    background-size: auto 25px;
    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACcAAAAfCAMAAABTVCTHAAAATlBMVEX///9LpXTl8uv7/fzO5tlOp3Z8vZplsoj0+fa/383s9fCq1b5jsodVq3z1+vfu9vLg7+fc7eTX6+Cu18GczbKPx6l/v5x4u5drtYxdroLxnfzQAAAAV0lEQVQ4y93ROxaAIAxE0SSAIoL/7/43akXKOVqaW79qhv5g8oBo5hkJc+1Whrraxb0BNkfWRAEGzZbCQNFD+pc7p7MFjkjmOICU3Azk9HVnyQG4RjLkAf5gBTGvchs5AAAAAElFTkSuQmCC');
}

.head-actions-item span {
    text-transform: uppercase;
    font-family: "Montserrat", sans-serif;
    color: #45464B;
    font-size: 10px;
    font-weight: 500;
    display: block;
    position: absolute;
    left: 0px;
    width: 100%;
    text-align: center;
    bottom: 0px;
}

.is-mobile .head-actions-item span {
    font-size: 9px;
    bottom: 4px;
}

.head-menu {
    position: absolute;
    right: 0px;
    bottom: 20px;
    display: flex;
}

.is-tablet .head-menu,
.is-mobile .head-menu {
    position: fixed;
    top: 0px;
    background-color: #fff;
    width: 100%;
    bottom: 0px;
    z-index: 1000;
    overflow-y: auto;
    left: 0px;
    flex-direction: column;
    padding-top: 64px;
}

.head-menu-item-text {
    height: 40px;
    line-height: 40px;
    color: #45464B;
    padding: 0px 20px;
    font-size: 16px;
    font-weight: 500;
    text-transform: uppercase;
    font-family: "Montserrat", sans-serif;
}

.head-menu-close {
    background-image: url(data:image/jpeg;base64,iVBORw0KGgoAAAANSUhEUgAAAC4AAAAuBAMAAACllzYEAAAAJ1BMVEUAAABLpnRQn3BLpXRLpXNKpXVLpXRLpHRLpXRKpXRLpnNNpnNLpXTv7oaxAAAADHRSTlMA0BDw35CAcODAoFAUvW6RAAAAzUlEQVQ4y4WUPQ7CMAxGLQZYKTMDILEwM7KxMjEzcAAGDsAFkDgKA1eoxI8QPhQZoi/SU6xkaG3rvVZN7Npwuzeu1fpsJ+9nKA+m/rGd+wT1uXtvG5dQ8FQ/uISC+ztdJRTcx+kGIYMQxCkArgi4QuCKwSghogy4UuLKgUsQDmGRcQpdxim4cAjCIQiHABz11nP4XuIU+F3NfeC+NfeZ5xKdY3juUZ+EfRX1Ydi3UZ9HcyGcwr06d69gTp92q8711y7V/8DPRt3RuJbXxx+isfauWCeT2AAAAABJRU5ErkJggg==);
    width: 40px;
    height: 40px;
    position: absolute;
    top: 12px;
    right: 12px;
    background-position: 50% 50%;
    background-repeat: no-repeat;
    background-size: 24px auto;
}

.is-tablet .head-menu-item-text,
.is-mobile .head-menu-item-text {
    font-size: 13px;
    line-height: 24px;
    height: auto;
    padding: 10px 20px;
    border-bottom: 1px solid #D5E3D7;
    background-image: url(data:image/jpeg;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAdBAMAAAC+gZqyAAAAG1BMVEUAAADV4tfW4tfV49jV5NXP38/V49fV49fV49czjIhVAAAACHRSTlMAYKDvMBDQwHmYA9oAAAA7SURBVBjTY2BQZIACpg4BKEujoxHKkuiACTJ20EnQuaNDAcxgsehooqEQQwVMiCEMJsTAmsQAAwFQGgAoiiNeJicIHwAAAABJRU5ErkJggg==);
    background-position: calc(100% - 20px) 50%;
    background-repeat: no-repeat;
    background-size: auto 14px;
}

.is-table .head-menu-item:first-child,
.is-mobile .head-menu-item:first-child {
    border-top: 1px solid #D5E3D7;
}

.head-menu-item.is-search {
    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAOVBMVEUAAAAAWjoAWD0AWD0AWEAAVz0AVz0AWD0AWT0AWD0AWT0AWD0AVz0AYEAAWD0AWD0AWTwAWDwAWD0DPn4xAAAAEnRSTlMAMGDAIPDQsHCAUOCvEN+gkEArkyFHAAAAyklEQVQ4y4VTWRaEMAijq3ZzZrj/YUfxWWzxSb6siRBohA6TXESMLhl4gt2wY8uC9g4HOD/yJuCEYAYeCR9r9me7nKebwtP3i+9nkgTuQv1XuGElH90/86PimqUc9WHC0WW7OfRibvaZDv8ATyVSt2ilwHabkWeedxPpCXcImt+rAr2FbvLLexJjqoviVdenAkW9LO26p8BUDkw9AyMiV8/I1StyTQltC/Y19i2OC8yF6ZIBGhVlhfz1LLJCghVZUwRQFAXekEP4/QHgexV7BAItLQAAAABJRU5ErkJggg==');
    background-repeat: no-repeat;
    background-position: 20px 50%;
    background-size: 16px 16px;
    width: 16px;
    margin-left: 32px;
}

.head-submenu {
    position: absolute;
    right: 0px;
    top: 0px;
    background-color: #FDF9F3;
    height: 50px;
    padding: 0px 10px;
    display: flex;
}

.is-mobile .head-submenu,
.is-tablet .head-submenu {
    position: relative;
    right: auto;
    margin-top: 20px;
    top: auto;
    background-color: #fff;
    display: grid;
    grid-template-columns: 1fr 1fr;
}

.head-submenu-item {
    line-height: 50px;
    padding: 0px 20px;
    color: #45464B;
    font-size: 14px;
    font-weight: 500;
    font-family: "Montserrat", sans-serif;
}

.is-mobile .head-submenu-item,
.is-tablet .head-submenu-item {
    line-height: 24px;
    padding: 5px 20px;
}

.head-submenu-item.is-phone {
    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAoBAMAAAAfyIccAAAAGFBMVEUAAADvx5fwyZTxyZTwyZTwyZTwyZXwyZRsQqNQAAAAB3RSTlMAIPCw4N+v7qVGoAAAAD9JREFUKM9jYEwth4MwAQahciSgyGCOzC1mUEfmljKUlzPAAJA9yqUpF0iSxKXcXtToLkFLDOhJhdEEwXMWAABWTW5CYc5gLgAAAABJRU5ErkJggg==');
    background-repeat: no-repeat;
    background-position: 20px 50%;
    background-size: 14px 20px;
    padding: 0px 20px 0px 45px;
}

.is-tablet .head-submenu-item.is-phone,
.is-mobile .head-submenu-item.is-phone {
    grid-column: span 2;
    padding: 10px 20px 10px 45px;
    margin-top: 20px;
    background-color: #FDF9F3;
}

</style>